import React from 'react'

import {
    Button,
} from '@material-ui/core'

import { FieldArray } from 'formik'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem4sm6xs12,
} from '../../../business-components/Grid/Grid'

import {
    PanelRadioGroup
} from '../../../business-components/RadioGroup/RadioGroup'

import {
    pesquisaDescricaoList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    obtemPage,
    salvaPage,
} from '../cliente-form/ClienteService'

import {
    TablePaginationPadraoEducacao,
    rowPertentePageEducacao,
    setPageInclusaoEducacao,
} from './DespesasCompEducacao'

import {
    incrementaContEducacao,
    processaRegistrosDefaultIniciaisEducacao,
    calculaEducacaoFilhaoEnteadaoBaseOutraosFilhaosEnteadaos,
    processaCopiaEducacaoFilhaoBaseOutraosFilhaos,
    processaValoresDefaultIniciaisEducacao,
    calculaTotaisEducacao,
} from './DespesasServiceEducacao'

import DespesasFormEducacaoItem from './DespesasFormEducacaoItem'



const DespesasFormEducacao = ({ values, handleChange, setFieldValue, jsonConfiguracao }) => {

    processaRegistrosDefaultIniciaisEducacao(values, jsonConfiguracao)

    calculaTotaisEducacao(values)

    calculaEducacaoFilhaoEnteadaoBaseOutraosFilhaosEnteadaos(values)

    useSingleton(async () => {

        values.pageEducacao = obtemPage(values.pageEducacaoList, Number.parseInt(values.familiarEducacao))
    })

    salvaPage(values.pageEducacao, values.pageEducacaoList, Number.parseInt(values.familiarEducacao))

    let indAux = 0
    
    values.educacaoPagination =
        values.educacao
            ?
                values.educacao.filter(item => item.familiar === Number.parseInt(values.familiarEducacao))
            :
                []



    return (
        <>
            <PanelRadioGroup
                name="familiarEducacao"
                value={Number.parseInt(values.familiarEducacao) || ''}
                onChange={(e) => {
                    values.pageEducacao = obtemPage(values.pageEducacaoList, Number.parseInt(e.target.value))
                    handleChange(e)
                }}
                list={values.totalEducacao}
                helpText={HELPTEXT.educacaoPanelRadioGroup}
            />

            <Button
                className="mt-1 mb-1"
                color="secondary"
                variant="contained"
                type="submit"
                style={{
                    display: 
                        values.idOutraosFilhaosEnteadaos.filter(linhaIdOutraosFilhaos =>
                        linhaIdOutraosFilhaos.id === Number.parseInt(values.familiarEducacao)).length === 1
                            ? "block"
                            : "none"
                }} 
                onClick={() =>
                    {
                        processaCopiaEducacaoFilhaoBaseOutraosFilhaos(values, Number.parseInt(values.familiarEducacao))
                    }
                }
            >
                {LABEL.buttonCopiaEducacaoFilhaoBaseOutraosFilhaos
                    .replace("$1", pesquisaDescricaoList(familiaresList(values), values.idFilhaoEnteadaoBase))
                    .replace("$2", pesquisaDescricaoList(familiaresList(values), Number.parseInt(values.familiarEducacao)))
                }
            </Button>
               
            <FieldArray name="educacao">
                {(arrayHelpers) => (
                    <DivForm>
                        <GridContainer>
                            {values.educacao?.map((item, ind) => {

                                processaValoresDefaultIniciaisEducacao(item)

                                return item.familiar === Number.parseInt(values.familiarEducacao) && rowPertentePageEducacao(values, indAux++) ? (
                                    <GridItem4sm6xs12
                                        key={ind}
                                    >
                                        <DespesasFormEducacaoItem
                                            values={values}
                                            handleChange={handleChange}
                                            setFieldValue={setFieldValue}
                                            arrayHelpers={arrayHelpers}
                                            item={item}
                                            ind={ind}
                                            simplificado={false}
                                        />
                                    </GridItem4sm6xs12>
                                )
                                :
                                (
                                   ''
                                )
                            })}
                        </GridContainer>

                        <TablePaginationPadraoEducacao
                            values={values}
                            setFieldValue={setFieldValue}
                        />

                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirEducacao} 
                            disabled={familiaresList(values).length === 0 || !values.familiarEducacao ? true : false}
                            onClick={() =>
                                {
                                    incrementaContEducacao(values)
                                    arrayHelpers.push({
                                        id: values.contEducacao,
                                        familiar: Number.parseInt(values.familiarEducacao)
                                    })
                                    setPageInclusaoEducacao(values, setFieldValue)
                                }
                            }
                        />
                    </DivForm>
                )}
            </FieldArray>
        </>
    )
}

export default DespesasFormEducacao